import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'enumToArray' })
export class EnumToArrayPipe implements PipeTransform {
    transform(value): Object {
        return Object.keys(value).map(elem => { return { index: elem, name: value[elem] } });
    }
}
